<template>
    <div class="transaction-summary">
        <div class="tile transaction-summary-tile">
            <div class="tile-title">
                <div class="tile-title-primary" v-fs-block>
                    <h2>{{ transaction.id }}</h2>
                    <div class="text-muted">from {{transaction.website.name}}</div>
                    <div class="margin-top-m"><router-link v-if="$auth.$pages['webhook-tracking-logs'].isAllowed" :to="webhookRoute">
                        View related webhook logs
                    </router-link></div>
                    <div><router-link v-if="$auth.$pages['api-logs'].isAllowed" :to="apiLogsRoute">
                        View related API logs
                    </router-link></div>
                </div>
                <div class="tile-title-secondary" v-fs-block>
                    <h2>{{ transaction.amount | monetizeExplicit(transaction.currency) }}</h2>
                    <span class="text-muted" v-if="transaction.processedTime">
                                    Processed on {{ transaction.processedTime | dateTime }}
                                </span>
                    <span class="text-muted" v-else>
                                    Scheduled on {{ transaction.scheduledTime | dateTime }}
                                </span>
                </div>
            </div>
            <transaction-summary-state-tags
                :transaction="transaction"/>
            <transaction-summary-timeline
                :transaction-status="transaction.status"/>
            <transaction-summary-actions
                :is-processing="isProcessing"
                :transaction="transaction"
                @action-starts="childActionStarts"
                @action-ends="childActionEnds"/>
            <template v-for="related in relatedTransactions">
                <transaction-summary-related
                    :is-processing="isProcessing"
                    :related-transaction="related"/>
            </template>
            <div v-if="transaction.isRetry && !transaction.isScheduled" class="tile-content">
                <transaction-summary-retry-message :retry="transaction">
                    <span slot-scope="retry">
                        This transaction was a retry {{retry.attempts}} from initial transaction
                    </span>
                </transaction-summary-retry-message>
            </div>
            <div v-else-if="!transaction.isRetry && transaction.lastRetry" class="tile-content">
                <transaction-summary-retry-message :retry="transaction.lastRetry"
                                                   :linkTransactionId="transaction.lastRetry.id">
                    <span slot-scope="retry">
                        This transaction has retries:<br>
                        Last retry {{retry.attempts}} was {{retry.result}} on {{retry.dateTime}}
                    </span>
                </transaction-summary-retry-message>
            </div>
        </div>
    </div>
</template>

<script>
    import TransactionSummaryStateTags from './transaction-summary/transaction-summary-state-tags';
    import TransactionSummaryTimeline from './transaction-summary/transaction-summary-timeline';
    import TransactionSummaryActions from './transaction-summary/transaction-summary-actions';
    import TransactionSummaryRelated from './transaction-summary/transaction-summary-related';
    import TransactionSummaryRetryMessage from './transaction-summary/transaction-summary-retry-message';
    import SegmentDataModel from '@/common/models/segment-data-model';

    export default {
        name: 'transaction-transaction-summary',
        components: {
            TransactionSummaryStateTags,
            TransactionSummaryTimeline,
            TransactionSummaryActions,
            TransactionSummaryRelated,
            TransactionSummaryRetryMessage,
        },
        props: {
            transaction: {
                type: Object,
            },
            isProcessing: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            relatedTransactions() {
                const {childTransactions: childIds, parentTransactionId: parentId} = this.transaction;
                const related = parentId ? [{label: 'parent', transactions: [parentId]}] : [];
                if (childIds.length) {
                    related.push({
                        label: 'child',
                        transactions: childIds,
                    });
                }
                return related;
            },
            webhookRoute() {
                return this.getLogRoute(SegmentDataModel.Types.webhookLogs);
            },
            apiLogsRoute() {
                return this.getLogRoute(SegmentDataModel.Types.apiLogs);
            },
        },
        methods: {
            childActionStarts() {
                this.$emit('action-starts');
            },
            childActionEnds(result) {
                this.$emit('action-ends', result);
            },
            getLogRoute(type) {
                const {id: resourceId} = this.transaction;
                return {
                    name: 'resource-log',
                    params: {
                        type,
                        resourceId,
                    },
                };
            },
        },

    };
</script>
